
<template>
  <h-list-page class="SQMList_style">
    <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" is-search @change-method="changeMethod">
      <h-area>
        <h-search :title="h_i18n('d9bcdd40b55107e97b9881d6e476bb20')">
          <h-input v-model="searchData.uniqueCode" clearable @change="changeNull(searchData.uniqueCode, 'uniqueCode')">
          </h-input>
        </h-search>

        <h-search :title="h_i18n('62eadaf8a7896d1d8cad08ee4131b959')">
          <h-input v-model="searchData.qrCode" clearable @change="changeNull(searchData.qrCode, 'qrCode')">
          </h-input>
        </h-search>

        <!-- <h-search title="检测项目">
          <h-input v-model="searchData.onlineTestProject" clearable @change="changeNull(searchData.onlineTestProject, 'onlineTestProject')">
          </h-input>
        </h-search>

        <h-search title="检测结果">
          <h-input v-model="searchData.testResult" clearable @change="changeNull(searchData.testResult, 'testResult')">
          </h-input>
        </h-search> -->

        <template #operate>
          <h-button type="primary" :loading="this.loading" @click="handleCurrentChange(1)">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>

      </h-area>
    </h-card>

    <h-table-card :title="h_i18n('54d52f565cc2e202d130dbb5e13c8ac4')" :is-left="2" :is-right="0" :h-data="tableData">
      <template #buttonGroup>
        
        <h-button-group>
          <!-- 导出 -->
          <h-button v-if="roleType" :loading="exportLoading" type="primary" @click="ExportSqm">
            <i class="iconfont icon-daochu"></i>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
          <div class="tipBox_yellow">
            <img src="@/assets/img/tips-icon.png" class="tip-img" />{{ h_i18n('6fce02a38267ac7ce89e3add5eeb1bae') }}</div>
        </h-button-group>
      </template>

      <el-table @current-change="clickrow" highlight-current-row
      :data="tableData"  size="small" border height="540" style="width: 100%;min-height: 540px">
      <el-table-column prop="prodNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="130"></el-table-column>
      <el-table-column prop="prodName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" min-width="200">
        <template #default="scope"><div style="text-align:left">{{scope.row.prodName}}</div></template>
      </el-table-column>
      <el-table-column prop="produceFacFullName" :label="h_i18n('4fe28e7de0d2d2138a5fcdd9869bd281')" width="180"></el-table-column>
      <el-table-column prop="adress" :label="h_i18n('6e3ef2295870257f741434e2f8cf646b')" width="180"></el-table-column>
      <el-table-column prop="prodBatch" :label="h_i18n('13b062af2976411b3f19c9820febe842')" width="160"></el-table-column>
      <el-table-column prop="lineCode" :label="h_i18n('24d6c9b03ed096d69b753505d691e3c4')" width="100"></el-table-column>
      <el-table-column prop="uniqueCode" :label="h_i18n('d9bcdd40b55107e97b9881d6e476bb20')" width="180"></el-table-column>
      <el-table-column prop="qrCode" :label="h_i18n('62eadaf8a7896d1d8cad08ee4131b959')" width="180"></el-table-column>
      <el-table-column prop="testTime" :label="h_i18n('44c4227175922c94497714edab9db531')" width="160"></el-table-column>
      <el-table-column prop="onlineTestProject" :label="h_i18n('22ec1277cd9a5f08ea93ec8aee06911b')" width="100"></el-table-column>
      <el-table-column prop="standard" :label="h_i18n('13dbc3bd9ab2901546e6efc9942b45c1')" width="100"></el-table-column>
      <el-table-column prop="testData" :label="h_i18n('337bffab47e921014ae18dea50127fae')" width="100"></el-table-column>
      <el-table-column prop="testResult" :label="h_i18n('77b9b1d1720981ebe160fd67cdd61db9')" width="100">
        <template #default="{ row }">
            <span v-if="row.testResult == '合格'" style="color: #70B60C;">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
            <span v-else-if="row.testResult == '不合格'" style="color: #d74c4d;">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
            <span v-else>{{ row.testResult }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        v-model:currentPage="pagenation.pageNo" :page-size="pagenation.pageSize" layout="total, prev, pager, next,jumper"
        :total="total">
      </el-pagination>
    </h-table-card>
  </h-list-page>
</template>


<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

export default {
    name: 'SQMlist',
    data() {
        return {
            pagenation:{
              pageNo:1,
              pageSize:10
            },
            tableData:[],
            total:0,
            modelNo:'',
            prodBatch:'',
            prodNo:'',
            roleType:'',
            searchData:{},
            loading:false,
            buttonList: [], 
            exportBtnCodeOfHac:'S01053_GCZXJC_DC',
            searchCount:0,
        }
    },
    methods: {
    h_i18n,
       /**
     * 传高度
     */
    changeMethod() {
      this.postThisPageHeight();
    },
    // 按钮公共处理函数
    // loading事件
    loadingEvent(code) {
      switch (code) {
        case this.exportBtnCodeOfHac:
          return this.exportLoading;
        default:
          return null;
      }
    },
    // btn事件
    btnFunOfBtn(code) {
      switch (code) {
        case this.exportBtnCodeOfHac:
          this.EXport();
          break;

        default:
          return null;
      }
    },

    // input为空时undefined
    changeNull(value, key) {
      if (value === "") {
        this.searchData[key] = undefined;
      }
    },
      clickrow(val){
        this.currentRow = val
      },
      handleCurrentChange(val) {
        console.log(val,'页码')
        this.pagenation.pageNo = val
        this.getReportLVist()
      },
      handleSizeChange(val) {
        console.log(val,'条数')
      },
      // 查询表格数据
      getReportLVist(){
        if(!this.searchData.uniqueCode && !this.searchData.qrCode){
                  this.info(h_i18n('9a4f5889a1329226c5a3cdeff9ff2ae3'))
                  return
                }
                this.searchCount ++
        this.loading = true;
        this.$http({
            method: 'post',
            url: '/base/onlineprocess/getAllDetails',
            // headers: {'content-type': 'application/json'},
            data:{
              // modelNo:this.modelNo,
              // prodBatch:this.prodBatch,
              // prodNo:this.prodNo,
              // modelNo:'V23456',
              // prodBatch:'生产批次',
              // prodNo:'ddd',
              ...this.pagenation,
              ...this.searchData,
              fixConfig:true,
            },
        }).then((res)=>{
          console.log(res,'查询到的数据')
          this.loading = false
          if(res.data.code==200){
            this.tableData = res.data.data.testOnlineDetailsDTOList
            this.total = res.data.data.total
          }else{
            this.tableData = []
            this.total = 0
          }
        });
      },
      
      ExportSqm(){
        if(this.searchData.uniqueCode || this.searchData.qrCode){
          this.searchCount ++
        }
        if(this.searchCount !== 1){
          if(!this.searchData.uniqueCode && !this.searchData.qrCode){
            this.info(h_i18n('e297b1a7803e53ec2de8ed9b3b84ff2a'))
            return
          }
        }
        //导出方法
        if (this.total > 10000) {
          this.info(h_i18n('5e918af24d6756bed29794c63232a10e'), h_i18n('f148292ae0c683ca6fe4246350d309f6'),{
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              callback: action => {
              }
          })
        }else {
          // 转换查询日期参数，添加hmqm默认参数
          this.startLoading(h_i18n('8acbf41bbeffe11af364eac8361b4730'))
                    this.exportLoading = true
        this.$http({
          method: 'post',
          url: '/base/onlineprocess/sqmexportAllDetailExcel',
          data: {
            modelNo:this.searchCount === 1 ? this.modelNo : undefined,
            prodBatch:this.searchCount === 1 ? this.prodBatch : undefined,
            prodNo:this.searchCount === 1 ? this.prodNo : undefined,
            ...this.searchData,
            fixConfig:true,
            },
          responseType: "blob"
        }).then((res)=>{
            if(res.status==200 ){
               let blob = new Blob([res.data], {type: "application/vnd.ms-excel"}); // 文件流
               let blobUrl = URL.createObjectURL(blob);
                const link = document.createElement("a"); //模拟a链接，不支持低版本ie

                link.download = h_i18n('316e5040e2dde1b78b9d76dc8dbd6e7d')+this.prodNo+'.xls';
                link.style.display = "none";
                link.href = blobUrl;
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(link.href);
                document.body.removeChild(link);

          }
        }).catch((err) => {
            console.log('导出失败',err);
            this.warning(h_i18n('CEB4728F29B8224B4B0D0F92BA3C54A4'))
        }).finally(()=>{
                      this.closeLoading();
            this.exportLoading = false
                    })

        }
      },
      getInfo(){
        this.loading = true
        this.searchCount = 1
        this.$http({
            method: 'post',
            url: '/base/onlineprocess/getAllDetails',
            data:{
              modelNo:this.modelNo,
              prodBatch:this.prodBatch,
              prodNo:this.prodNo,
              pageNo: 1,
              pageSize:10
            },
        }).then((res)=>{
          console.log(res,'查询到的数据')
          this.loading = false
          if(res.data.code==200){
            this.tableData = res.data.data.testOnlineDetailsDTOList
            this.total = res.data.data.total
          }else{
            this.tableData = []
            this.total = 0
          }
        }).finally(()=>{
          this.loading = false
        })
      }

    },
    mounted(){
      this.modelNo = this.$route.query.modelNo
      this.prodBatch = this.$route.query.prodBatch
      this.prodNo = this.$route.query.prodNo
      this.getInfo()
      // this.getReportLVist();
      if(this.$route.query.roleType){
          this.roleType = this.$route.query.roleType === "false" ? false : true;
      }
    },
}
if(window.location.search){
  let search= window.location.search
  window.location.replace("/#/SQMlist"+search)
}
</script>

<style lang="scss">
.tipBox_yellow {
    padding: 4px 16px;
    border: 1px solid #ffe4ba;
    background-color: #fff7e8;
    border-radius: 6px;
    line-height: 20px;
    height: auto;
    color: #1D2129;
    font-size: 14px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-left: 12px;

    img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
    .reportTemplateList{
        width: 1150px;
        margin: 0px auto;
        height: auto;
        overflow: visible;
        background: white;
        font-size: 12px;
        padding: 10px;
        .search{
          .searchLable{
            width: 30%;
          }
          .searchContent{
            width: 70%;
          }
        }
        .disableBut{
            color: gray !important;
            cursor: default !important;
        }
        .lable-left{
            margin-top: 0px;
            padding-right: 20px;
            border-bottom: 1px solid #E5E6E7;
            span{
                font-size: 1.5em;
                line-height: 33px;
                color: #333;
            }
            i{
                color: #387CD7;
                padding-right: 10px;
            }
        }
    }
</style>